exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".viewport-wrap-box{width:100%;height:100%;overflow:auto;font-size:0;background:#313039}.viewport-wrap-box.light{background:#f8faff}\n", ""]);

// exports
